import api from 'plugin/api';

/**
 *  보고서 - 주요원료도입현황
 */

/**
 *  @description 주요원료도입현황 API
 */
async function mjRwmtrReport(params) {
  const url = '/sfsh/report/mjRwmtr';

  const response = await api.get(url, { params });
  return response;
}

export { mjRwmtrReport };
